import { dispatchAlertToaster } from 'adapter/in/common/context/Alert';
import i18n from 'asset/translation';
import React, { createContext, useContext, useRef, ReactNode } from 'react';

type ExportChartType = {
    type: string;
};
export type ChartRefObject = {
    chart: { exportChart: (exportParams: ExportChartType) => void };
} | null;

type ChartExportContextProps = {
    exportChartAsPNG: () => void;
    setChartRef?: (ref: React.MutableRefObject<ChartRefObject>) => void;
};

const ChartExportContext = createContext<ChartExportContextProps>({
    exportChartAsPNG: () => {
        throw new Error('useChartExport must be used within a ChartExportProvider');
    },
});

export const useChartExport = (): ChartExportContextProps => useContext(ChartExportContext);

interface ChartExportProviderProps {
    children: ReactNode;
}

export const ChartExportProvider: React.FC<ChartExportProviderProps> = ({ children }) => {
    let chartRef = useRef<ChartRefObject>(null);
    const { setErrorAlert } = dispatchAlertToaster();

    const setChartRef = (ref: React.MutableRefObject<ChartRefObject>) => {
        chartRef = ref;
    };

    const exportChartAsPNG = () => {
        if (chartRef.current) {
            chartRef.current.chart.exportChart({
                type: 'image/png',
            });
        } else {
            setErrorAlert(i18n.t('advancedAnalytics.exportChartAsPNGNotAvailable'));
        }
    };

    return <ChartExportContext.Provider value={{ setChartRef, exportChartAsPNG }}>{children}</ChartExportContext.Provider>;
};
